import { IDefineCommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { APStudentDetailsQuery } from '../../global/components/student_details/queries/student_details_query';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';

angular
  .module('capability-ng-academic-planner')
  .service(
    'removeMmCourseFromTermCommand',
    function removeMmCourseFromTermCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngAPStudentDetailsQuery: APStudentDetailsQuery,
      accountModel: AccountModel,
      log: any,
      ngAPNotificationDelegate: INotificationDelegate
    ) {
      return defineCommand(
        'removeMmCourseFromTermCommand',
        function removeMmCourseFromTermCommand(deferred: any, plannedCourseId: number = 0) {
          const studentId = _4.get(accountModel, 'student_nk', 0) || _4.get(ngAPStudentDetailsQuery, 'result.id', 0);
          $http
            .delete(`academicplan/students/${studentId}/planned_courses/${plannedCourseId}`)
            .then(() => {
              deferred.resolve(studentId);
            })
            .catch((error: any) => {
              ngAPNotificationDelegate.error(`Failed to remove course from term`);
              log.issue('Failed to remove course from term');
              deferred.reject(error.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/remove_mm_course_from_term_command.ts